import React from 'react';
import { LoadingIndicatorLayout } from '../Layout/LoadingIndicatorLayout';
import { IconSuccess } from '../Icons';

const { LoadingIndicatorWrapper, SpinnerWrapper, SpinnerLoadingCircle, SpinnerSuccessCircle, LoadingIndicatorMessage } =
  LoadingIndicatorLayout;

/**
 * Displays a loading spinner and a success circle after loading completes.
 * Ideal for components with a large display area.
 * @param {boolean} isLoading
 * @param {JSX.Element} loadingMessage
 * @param {JSX.Element} successMessage
 * @param {string} className
 */
export const LoadingIndicator = ({ isLoading = true, loadingMessage = '', successMessage = '', className }) => {
  return (
    <LoadingIndicatorWrapper className={className}>
      <SpinnerWrapper>
        {isLoading ? (
          <SpinnerLoadingCircle />
        ) : (
          <SpinnerSuccessCircle>
            <IconSuccess />
          </SpinnerSuccessCircle>
        )}
      </SpinnerWrapper>
      <LoadingIndicatorMessage>{isLoading ? loadingMessage : successMessage}</LoadingIndicatorMessage>
    </LoadingIndicatorWrapper>
  );
};
